module.exports = __webpack_public_path__ + "img/silver-dark.8eb09e26.png";